import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { isArray } from "lodash";
import { t } from "i18next";

import { Icon, RangeSlider } from "components";
import { unitSliceData } from "slices";
import { budgetFormat, translations } from "components/UnitsView/utils";
import { useClickOutside } from "hooks";
import { translation } from "utils";

import "./styles.css";

const values = {
  bedrooms: "bedroom",
  budgets: "budget",
  allFloorPlans: "floorPlan",
};

const budgetsExtra = ["Custom Range", "Any"];

export const SelectComponent = ({ item, data, filterData, selectorType, handleSelectedValue, isAny, customBudget, defaultValue }) => {
  const pickerRef = useRef(null);

  const unitData = useSelector(unitSliceData);

  const [isOpened, setIsOpened] = useState(false);
  const [isInputOpened, setIsInputOpened] = useState(false);
  const [selected, setSelected] = useState(defaultValue || item == "budgets" ? "Any" : "All");

  const isDisabled = item !== "bedrooms" && selectorType === "All";

  const anyBudgetRange = unitData?.budgets?._custom_price_range ? budgetFormat(unitData?.budgets?._custom_price_range) : null;

  const dataArr = !data ? (isArray(unitData[item]) ? unitData[item] : unitData?.[item]?._form_desired_price_range) : data;

  const selectorArray =
    item == "bedrooms" ? [{ Display: "All", value: "All" }, ...dataArr] : item === "allFloorPlans" ? [{ name: "All", id: null }, ...dataArr] : dataArr;

  const getPriceRange = (source) => {
    const range = budgetFormat(source);

    const isRangeAvail = selectorArray.find((item) => item.Display === range?.replaceAll(" ", ""));

    return range === anyBudgetRange ? (isAny ? "Any" : selected !== "Any" && isRangeAvail ? range : "Any") : range || "";
  };

  useClickOutside(pickerRef, () => {
    if (isOpened || isInputOpened) {
      setIsOpened(false);
      setIsInputOpened(false);

      if (selected == "Custom Range") {
        item !== "Custom" && filterData && setSelected(!filterData[item] ? "Any" : getPriceRange(filterData[item]));
      }
    }
  });

  useEffect(() => {
    if (defaultValue) {
      if (item == "budgets") {
        setSelected(getPriceRange(defaultValue));
      } else {
        setSelected(defaultValue);
      }
    }
  }, [defaultValue]);

  const onDropdownClick = () => {
    if (isDisabled) {
      return;
    }

    if (isInputOpened) {
      setIsInputOpened(false);

      item !== "Custom" && filterData && setSelected(!filterData[item] ? "Any" : getPriceRange(filterData[item]));

      return;
    }

    setIsOpened((prev) => !prev);
  };

  const handleChange = async (val) => {
    setSelected(val);
    setIsOpened(false);
    handleSelectedValue(val, item);
  };

  const isRangeCustom = !selectorArray?.filter((v) => budgetFormat(v.value) === selected)?.length && selected !== "Any";

  return (
    <div data-testid="cols" className="move-in-picker-div" ref={pickerRef}>
      <div
        className={`move-in-picker-button ${isDisabled ? " hayley-cursor-default hayley-opacity-30" : " hayley-text-secondary hayley-opacity-75"}`}
        onClick={onDropdownClick}
      >
        <span className={`move-in-picker-text`}>
          {t(values[item])} (
          {item === "allFloorPlans" && !selected?.id
            ? `All - ${selectorArray.length - 1}`
            : `${translation(translations[selected?.name || selected], selected) || t(selected?.name || selected)}`}
          )
        </span>
        <Icon iconType={isOpened || isInputOpened ? "up" : "down"} className="move-in-picker-icon" />
      </div>
      {isOpened ? (
        <div className={`move-in-picker-dropdown`}>
          {selectorArray.map((v, i) => {
            const value = item === "allFloorPlans" ? v.name : budgetFormat(v.value);

            const trans = translations[value] || value;

            return (
              <div
                key={i}
                onClick={() => handleChange(item === "allFloorPlans" ? v : value)}
                className={`move-in-picker-dropdown-item hayley-px-3 hover:hayley-bg-gray-100 ${
                  selected === value || selected?.name === value ? "move-in-selected-item" : ""
                }`}
              >
                {translation(trans, value)}
              </div>
            );
          })}
          {item === "budgets" &&
            budgetsExtra.map((v, i) => (
              <div
                key={i}
                onClick={() => {
                  setIsOpened(false);
                  setSelected(v);

                  if (v === "Any") {
                    handleSelectedValue(anyBudgetRange, item);

                    return;
                  }

                  setIsInputOpened(true);
                }}
                className={`move-in-picker-dropdown-item hayley-px-3 hover:hayley-bg-gray-100 ${
                  selected === v || (v === "Custom Range" && isRangeCustom) ? "move-in-selected-item" : ""
                }`}
              >
                {translation(translations[v], v)}
              </div>
            ))}
        </div>
      ) : null}
      {isInputOpened ? (
        <div className={`move-in-picker-dropdown hayley-w-[50%] hayley-min-w-[300px] hayley-max-w-[600px]  `}>
          <RangeSlider
            customBudget={customBudget}
            range={unitData?.budgets?._custom_price_range}
            onSelect={(v) => {
              handleSelectedValue(budgetFormat(v), item);
              setIsInputOpened(false);

              setSelected(budgetFormat(v));
            }}
          />
        </div>
      ) : null}
    </div>
  );
};
